import React from 'react'
import clsx from 'clsx'
import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import AddIcon from '@material-ui/icons/Add'

const ListHeader = ({
  smallTitle,
  bigTitle,
  canCreate = true,
  createText,
  createRedirect,
  goBack,
  secondaryButtonText,
  secondaryButtonRedirect,
  noIcon,
}) => {
  const classes = useStyles()
  return (
    <div className={classes.header}>
      <div>
        {smallTitle && (
          <text className={classes.title} onClick={goBack}>
            {smallTitle}
          </text>
        )}
        {bigTitle && <h2 className={classes.bigTitle}>{bigTitle}</h2>}
      </div>
      <div>
        {secondaryButtonText && (
          <Button
            variant="contained"
            onClick={secondaryButtonRedirect}
            className={clsx(classes.primaryButton, classes.withRightMargin)}
          >
            {secondaryButtonText}
          </Button>
        )}
        {canCreate && (
          <Button
            className={classes.primaryButton}
            variant="contained"
            color="primary"
            startIcon={noIcon ? null : <AddIcon />}
            onClick={createRedirect}
          >
            {createText}
          </Button>
        )}
      </div>
    </div>
  )
}

const useStyles = makeStyles({
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
  },
  title: {
    fontSize: '16px',
    color: '#3068F9',
    cursor: 'pointer',
  },
  bigTitle: {
    marginTop: '8px',
    marginBottom: 0,
    fontSize: '32px',
    color: '#304968',
  },
  primaryButton: {
    backgroundColor: '#3068F9',
    borderRadius: '8px',
    '&:hover': {
      backgroundColor: '#0539be',
      boxShadow: 'none',
    },
    '& .MuiSvgIcon-root': {
      fill: 'white',
    },
    padding: '12px 24px',
    transition: 'all .5s ease',
    boxShadow: 'none',
  },
  withRightMargin: {
    marginRight: '16px',
  },
})

export default ListHeader
